import { useEffect, useState } from 'react';

import {
  getReconciliationFreeze,
  type ReconciliationFreeze,
} from 'src/pages/admin/services/vaultService';

/**
 * XBIT-4864: the vault's reconciliation freeze, for the detail's banner. Null while unread, unknown or not frozen: a failed
 * read shows no banner rather than guess. NOT the closure's `freezeAt` / `FROZEN` (the closure-notice freeze).
 * TODO(XBIT-4861): the data source is a stub until the BFF serves the freeze read (see getReconciliationFreeze).
 */
export const useVaultFreeze = (vaultId: string): ReconciliationFreeze | null => {
  const [freeze, setFreeze] = useState<ReconciliationFreeze | null>(null);

  useEffect(() => {
    let current = true;
    setFreeze(null);
    getReconciliationFreeze(vaultId).then(
      (next) => {
        if (current) setFreeze(next?.frozen ? next : null);
      },
      () => {
        if (current) setFreeze(null);
      }
    );
    return () => {
      current = false;
    };
  }, [vaultId]);

  return freeze;
};
